export const FREE_PLAN_LIMIT = 20
